document.addEventListener("DOMContentLoaded", () => {
  const floatBtn = document.querySelector("[data-floating-btn]");
  const modalVideosWrap = document.querySelector("[data-modal-wrapper]");
  const modalVideos = document.querySelector("[data-modal-card]");
  const closeBtn = document.querySelector("[data-close-pop]");

  // Show popup after 5 seconds only if not shown before in this session
  if (!sessionStorage.getItem("modalShown")) {
    setTimeout(() => {
      modalVideosWrap.classList.remove("hidden");
      sessionStorage.setItem("modalShown", "true"); // So it doesn't show again
    }, 5000);
  }

  // Open modal manually by button
  floatBtn?.addEventListener("click", () => {
    modalVideosWrap.classList.remove("hidden");
  });

  // Close modal when clicking outside of the modal card
  modalVideosWrap?.addEventListener("click", (e) => {
    if (e.target === modalVideosWrap) {
      modalVideosWrap.classList.add("hidden");
    }
  });

  // Close modal when clicking the close button
  closeBtn?.addEventListener("click", () => {
    modalVideosWrap.classList.add("hidden");
  });
});
